import { Reveal } from "../../components/Reveal";
import SectionNav from "../../components/SectionNav";
import { PageHero, SectionHead, CtaBand } from "../../components/ui";
import Accordion from "../../components/Accordion";
import { FAQS } from "../../data/site";

const FAQ_SECTIONS = [
    { id: "faq-about", label: "About AddiGen" },
    { id: "faq-storage", label: "About energy storage" },
];

export default function Faq() {
    return (
        <>
            <PageHero
                eyebrow="Company — FAQ"
                lines={["Questions, answered", "plainly."]}
                trail={[{ label: "Home", path: "/" }, { label: "Company" }, { label: "FAQ" }]}
            />
            <SectionNav items={FAQ_SECTIONS} navKey="faq" />
            <section className="bg-paper">
                <div className="container-x py-20 sm:py-24 lg:py-28">
                    <div id="faq-about" className="grid scroll-mt-36 gap-16 lg:grid-cols-12">
                        <div className="lg:col-span-4">
                            <SectionHead
                                eyebrow="Group 01"
                                title="About AddiGen"
                            />
                            <Reveal><p className="body-sm mt-6 max-w-xs">The company, its markets and its position in the European energy system.</p></Reveal>
                        </div>
                        <div className="lg:col-span-8">
                            <Reveal>
                                <Accordion items={FAQS.about} testPrefix="faq-about" />
                            </Reveal>
                        </div>
                    </div>
                    <div id="faq-storage" className="mt-20 grid scroll-mt-36 gap-16 lg:mt-28 lg:grid-cols-12">
                        <div className="lg:col-span-4">
                            <SectionHead
                                eyebrow="Group 02"
                                title="About energy storage"
                            />
                            <Reveal><p className="body-sm mt-6 max-w-xs">CAES, BESS and the role of long-duration storage in Europe's power system.</p></Reveal>
                        </div>
                        <div className="lg:col-span-8">
                            <Reveal>
                                <Accordion items={FAQS.storage} testPrefix="faq-storage" />
                            </Reveal>
                        </div>
                    </div>
                </div>
            </section>
            <CtaBand cta="Ask a question" />
        </>
    );
}
